import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { CloudinaryImage, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroProductImage = (props: Props) => {
  const { alt, url } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const imageStyles = match([styles.imageXS, styles.imageSM]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.outerContainer}>
      <View style={styles.container}>
        <CloudinaryImage
          baseUrl={url}
          config={IMAGE_CONFIG}
          contentFit="cover"
          style={imageStyles}
          alt={alt}
        />
      </View>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_SIZE_XS = 80;
const IMAGE_SIZE_SM = 120;

const IMAGE_CONFIG: CloudinaryImageConfig = {
  width: IMAGE_SIZE_SM,
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    position: 'absolute',
    right: theme.spacing['4'],
    bottom: theme.spacing['4'],
  },
  container: {
    aspectRatio: 1,
    backgroundColor: theme.colors.CREAM,
    borderColor: theme.colors.BROWN,
    borderRadius: theme.radius['3xLarge'],
    borderWidth: 2,
    flex: 1,
    overflow: 'hidden',
  },
  imageXS: {
    width: IMAGE_SIZE_XS,
    height: IMAGE_SIZE_XS,
  },
  imageSM: {
    width: IMAGE_SIZE_SM,
    height: IMAGE_SIZE_SM,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  alt: string;
  url: string;
};

type CloudinaryImageConfig = ComponentProps<typeof CloudinaryImage>['config'];
